import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React from 'react';
import  StringTooltipIcon from '@/assets/images/icons/string-tooltip-icon.react.svg?react';
import styles from './hintText.module.scss';

export const ABTEST_TIPS = '多选表示OR关系';

export const BUNDLE_TIPS_CASE = '只支持查看2023年6月26日之后最近90天的数据。';

export const BUNDLE_TIPS_ANALYTICS = '只支持查看2023年6月26日之后最近180天的数据。';

export const FD_TIPS = 'SDK >= 4.1.33.3 才支持采集该信息，信息采集后，在下一次启动才上报。可能存在部分个例，采集失败。';
export const PROCESS_INFORMATION_TIPS = 'SDK >= 4.1.33.3 的Native崩溃才支持采集该信息，信息采集后，在下一次启动才上报。可能存在部分个例，采集失败。';

export const ANDROID_LOG_TIPS = '可能存在部分个例，采集失败。';
export const IOS_LOG_TIPS = 'SDK >= 2.7.35 ，用户需要通过「自定义文件」上报并查看日志。';

export const SCHEDULING_SEQUENCE_CHART_TIPS = 'ANR发生前，UI线程的消息调度时序图。SDK >= 4.2.0 才支持采集该信息。';

export const ANR_INFO_TIPS = '对应ProcessErrorStateInfo.longMsg。大部分机型在系统发出ANR信号后，会直接杀死进程，因此来不及获取对应的ANR信息。';

export const ANR_TRACE_TIPS = '可能存在部分个例，采集信息失败。';

export const FD_LEAK_CEIL_QIMEI_TIPS = 'FD设备触顶率 =（fd_leak事件的去重设备数）/（开启了FD触顶监控的去重设备数）';

export const FD_LEAK_CEIL_ACCOUNT_TIPS = 'FD人数触顶率 =（fd_leak事件的去重用户数）/（开启了FD触顶监控的去重用户数）';

export const FD_LEAK_CEIL_TIMES_TIPS = 'FD次数触顶率 =（fd_leak事件的上报次数）/（开启了FD触顶监控的次数）';

export const HIPPY_EXT_PARAM_TIPS = 'string, 自定义上报的额外维度，对应SDK的同名上报字段，支持多种匹配模式。';

export const HIPPY_EXT_HINT = '多个值通过按回车分割';

export const hintText = (label: string, tips: React.ReactNode) => <Tooltip
  title={tips}
  overlayStyle={{ maxWidth: 500 }}
>
  {label} <QuestionCircleOutlined style={{ color: '#A3A3A9', fontSize: '14px' }}/>
</Tooltip>;

export const hintIconText = (
  label: string | React.ReactNode, tips: React.ReactNode,
  placement?: TooltipPlacement,
  onVisibleChange?: (open: boolean) => void,
  maxWidth?: number,
) => <span>{label}<Tooltip
  title={tips}
  overlayStyle={{ maxWidth: maxWidth ?? 500 }}
  placement={placement || 'top'}
  onVisibleChange={onVisibleChange}
>
    <QuestionCircleOutlined style={{ color: '#A3A3A9', fontSize: '14px', marginLeft: 4 }}/>
  </Tooltip></span>;

export const hintStringIconText = (
  label: React.ReactNode,
  tips: React.ReactNode,
  splitValue: () => void,
  placement?: TooltipPlacement,
  onVisibleChange?: (open: boolean) => void,
) => <span>{label}<Tooltip
  title={tips}
  overlayStyle={{ maxWidth: 500 }}
  placement={placement || 'top'}
  onVisibleChange={onVisibleChange}
>
   <span style={{ marginLeft: '4px' }} onClick={splitValue}><StringTooltipIcon className={styles.stringTooltipIcon} /></span>
  </Tooltip></span>;


export const hintChildren = (
  label: string | React.ReactNode,
  tips: React.ReactNode | string,
  placement?: TooltipPlacement,
) => <Tooltip
  title={tips}
  overlayStyle={{ maxWidth: 500 }}
  placement={placement || 'top'}
  overlayClassName={'break-all'}
>
  {label}
</Tooltip>;


export const hintStringIcon = (
  tips: React.ReactNode,
  splitValue: () => void,
  placement?: TooltipPlacement,
  onVisibleChange?: (open: boolean) => void,
) => <Tooltip
  title={tips}
  overlayStyle={{ maxWidth: 500 }}
  placement={placement || 'top'}
  onVisibleChange={onVisibleChange}
>
   <span style={{ marginLeft: '4px' }} onClick={splitValue}>
     <StringTooltipIcon className={styles.stringTooltipIcon} />
   </span>
  </Tooltip>;

export const iconText = (
  tips: React.ReactNode,
  placement?: TooltipPlacement,
  onVisibleChange?: (open: boolean) => void,
  maxWidth?: number,
  style?: React.CSSProperties,
) => <Tooltip
  title={tips}
  overlayStyle={{ maxWidth: maxWidth ?? 500 }}
  placement={placement || 'top'}
  onVisibleChange={onVisibleChange}
>
    <QuestionCircleOutlined style={style ?? { color: '#A3A3A9', fontSize: '14px', marginLeft: 4 }}/>
  </Tooltip>;


export const MODEL_LABEL = hintIconText('机型', '鼠标悬浮可展示对应机器名称');
